// E-Ticaret › Vitrin Alanları sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.showcaseAreas';

export const ecommerceShowcaseAreasGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Vitrin Alanları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Ana sayfadaki Çok Satanlar, Trend, Yeni Gelenler ve Outlet gibi ürün bölümlerini buradan doldurursunuz. Hangi ürünlerin hangi sırayla görüneceğini siz seçersiniz; "Tümünü Gör" yalnız o alandaki ürünlere gider. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Vitrin Alanları'),
    toolbar: t(`${G}.regions.toolbar`, 'Yeni alan'),
    table: t(`${G}.regions.table`, 'Alan kartları'),
  },
  steps: [
    {
      region: 'table',
      title: t(`${G}.s1.title`, '1. Alanları tanıyın'),
      text: t(`${G}.s1.text`, 'Her kartta alanın türü (Çok Satan, Trend, Yeni, Outlet, Özel), başlığı, adresi (/slug), ürün sayısı ve ilk ürünlerin küçük görselleri görünür. Karttaki anahtar alanı ana sayfada gösterir ("Ana sayfada") ya da gizler ("Gizli"); değişiklik hemen kaydedilir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Hazır gelen alanlar (Çok Satan, Trend vb.) silinemez; yalnız düzenlenebilir veya gizlenebilir. "Yeni alan" ile eklediğiniz özel alanlar "Sil" ile kalıcı olarak silinir.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Alan oluşturun veya düzenleyin'),
      text: t(`${G}.s2.text`, '"Yeni alan" boş bir özel alan, karttaki "Düzenle" mevcut alanı açar. "Kimlik" bölümünde Başlık (zorunlu), Slug, Alt başlık ve Rozet yazılır. Slug, "Tümünü Gör" sayfasının adresini belirler: /showcase/slug.'),
      tips: [
        t(`${G}.s2.tip1`, 'Rozet metni (ör. "Yeni", "%20") kart tasarımındaki rozette gösterilir; rozetin görünümü "Kart tasarımı" bölümünden ayarlanır.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Ürünleri ekleyin ve sıralayın'),
      text: t(`${G}.s3.text`, '"Ürünler" bölümündeki "Ürün ara ve ekle" kutusuna ürün adı veya stok kodu yazıp ürünleri seçin. Seçilen ürünler numaralı listede görünür; yukarı / aşağı oklarla sırasını değiştirin, çarpı ile çıkarın. Sitede ürünler bu sırayla gösterilir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Hiç ürün eklenmemiş alan ana sayfada görünmez.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Başlık, animasyon ve kart tasarımı'),
      text: t(`${G}.s4.text`, '"Başlık ve animasyon" bölümünde başlığın hizasını (Sol, Orta, Sağ), boyutunu ve giriş animasyonunu (Aşağıdan yukarı / Sağdan sola kayarak) seçin; önizleme hemen altta görünür. "Kart tasarımı"nda "Mevcut ürün kartı" mağazanın genel kart şablonunu kullanır; "Doğal ürün kartı" seçilince zemin, kolon sayısı, kart, rozet ve diğer öğelerin renk ve boyut ayarları açılır.'),
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Ana sayfada gösterme'),
      text: t(`${G}.s5.text`, '"Ana sayfa" bölümünde "Ana sayfada göster" anahtarını açın; "Kaç ürün" (4, 8 veya 12) ana sayfada kaç ürünün görüneceğini, "Düzen" ürünlerin Izgara mı Kaydırma mı gösterileceğini, "Yerleşim" ise alanın ana sayfadaki yerini belirler: Slider\'dan sonra, Güven şeridinden sonra (önerilen) veya Modüllerden sonra.'),
      tips: [
        t(`${G}.s5.tip1`, '"Tümünü Gör butonu" açıksa alanın altında, "Buton metni"nde yazdığınız adla alanın tüm ürünlerini gösteren sayfaya giden bir düğme çıkar.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Kaydedin'),
      text: t(`${G}.s6.text`, 'Düzenleme ekranının altındaki "Kaydet" ile değişiklikleri kaydedin; "İptal" veya sol üstteki geri oku kaydetmeden listeye döner. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
